export const TIMEOUT = 30000;
const SERVER_ENDPOINT = process.env.REACT_APP_ENVIRONMENT === 'prod' ? process.env.REACT_APP_SERVER_PROD_ENDPOINT : process.env.REACT_APP_SERVER_DEV_ENDPOINT;
export const api = {
  baseUrl:
    `${SERVER_ENDPOINT}/${process.env.REACT_APP_API_VERSION}/` ||
    "/api/v1/",
};
